function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.84 45.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M32.24,45.83H9.6A9.62,9.62,0,0,1,0,36.22V9.6A9.62,9.62,0,0,1,9.6,0H32.24a9.61,9.61,0,0,1,9.6,9.6V36.22A9.61,9.61,0,0,1,32.24,45.83ZM9.6,4A5.6,5.6,0,0,0,4,9.6V36.22a5.61,5.61,0,0,0,5.6,5.61H32.24a5.61,5.61,0,0,0,5.6-5.61V9.6A5.6,5.6,0,0,0,32.24,4Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.32,37.55H10.56a2,2,0,0,1,0-4H31.32a2,2,0,1,1,0,4Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.32,29.13H10.56a2,2,0,1,1,0-4H31.32a2,2,0,0,1,0,4Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.32,20.7H10.56a2,2,0,1,1,0-4H31.32a2,2,0,0,1,0,4Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.32,12.28H10.56a2,2,0,0,1,0-4H31.32a2,2,0,0,1,0,4Z",
    style: {
      fill: "currentColor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.4f3a0df6.svg";
export { ForwardRef as ReactComponent };